module.exports = __webpack_public_path__ + "static/media/orion_control_logo.3d5f6dfe.svg";